import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=da09e0f4"
import script from "./AppMenu.ts?vue&type=script&lang=ts&external"
export * from "./AppMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports